import { DefaultLayout } from '@fondationcss/ui';
import { arkivSignatureRoutes } from '@fondationcss/arkiv-signature';

export const getCustomRoutes = () => [
  {
    path: '/',
    component: DefaultLayout,
    meta: { title: "Arkiv", },
    children: [
      {
        name: 'default-home',
        path: '',
        redirect: '/efvp'
      },

      // E-signature (reusable @fondationcss/arkiv-signature package)
      ...arkivSignatureRoutes,

      // EFVP
      {
        name: 'efvp-list',
        path: 'efvp',
        component: () => import('@/views/efvp/EfvpListView.vue')
      },
      {
        name: 'efvp-new',
        path: 'efvp/new',
        component: () => import('@/views/efvp/EfvpFormView.vue')
      },
      {
        name: 'efvp-edit',
        path: 'efvp/:id',
        component: () => import('@/views/efvp/EfvpFormView.vue')
      },
      {
        name: 'efvp-compliance',
        path: 'efvp/:id/compliance',
        component: () => import('@/views/efvp/EfvpComplianceView.vue')
      },

      // MCN
      {
        name: 'mcn-list',
        path: 'mcn',
        component: () => import('@/views/compliance/ComplianceListView.vue'),
        props: { complianceType: 'mcn', title: 'Évaluations MCN', newLabel: 'Nouvelle MCN', routePrefix: 'mcn' },
      },
      {
        name: 'mcn-new',
        path: 'mcn/new',
        component: () => import('@/views/mcn/McnFormView.vue')
      },
      {
        name: 'mcn-edit',
        path: 'mcn/:id',
        component: () => import('@/views/mcn/McnFormView.vue')
      },
      {
        name: 'mcn-compliance',
        path: 'mcn/:id/compliance',
        component: () => import('@/views/compliance/ComplianceComplianceView.vue'),
        props: { complianceType: 'mcn', routePrefix: 'mcn' },
      },

      // Archives
      {
        name: 'archives-list',
        path: 'archives',
        component: () => import('@/views/compliance/ComplianceListView.vue'),
        props: { complianceType: 'archives', title: 'Évaluations Archives', newLabel: 'Nouvelle évaluation', routePrefix: 'archives' },
      },
      {
        name: 'archives-new',
        path: 'archives/new',
        component: () => import('@/views/archives/ArchivesFormView.vue')
      },
      {
        name: 'archives-edit',
        path: 'archives/:id',
        component: () => import('@/views/archives/ArchivesFormView.vue')
      },
      {
        name: 'archives-compliance',
        path: 'archives/:id/compliance',
        component: () => import('@/views/compliance/ComplianceComplianceView.vue'),
        props: { complianceType: 'archives', routePrefix: 'archives' },
      },

      // CAI
      {
        name: 'cai-list',
        path: 'cai',
        component: () => import('@/views/compliance/ComplianceListView.vue'),
        props: { complianceType: 'cai', title: 'Évaluations CAI', newLabel: 'Nouvelle évaluation', routePrefix: 'cai' },
      },
      {
        name: 'cai-new',
        path: 'cai/new',
        component: () => import('@/views/cai/CaiFormView.vue')
      },
      {
        name: 'cai-edit',
        path: 'cai/:id',
        component: () => import('@/views/cai/CaiFormView.vue')
      },
      {
        name: 'cai-compliance',
        path: 'cai/:id/compliance',
        component: () => import('@/views/compliance/ComplianceComplianceView.vue'),
        props: { complianceType: 'cai', routePrefix: 'cai' },
      },

      // Document management — browser
      { name: 'doc-home', path: 'doc', redirect: '/doc/vaults' },
      { name: 'doc-vault-list', path: 'doc/vaults', component: () => import('@/views/doc/browser/VaultListView.vue') },
      { name: 'doc-vault-browser', path: 'doc/vaults/:vaultId', component: () => import('@/views/doc/browser/VaultBrowserView.vue') },
      { name: 'doc-document-detail', path: 'doc/vaults/:vaultId/documents/:documentId', component: () => import('@/views/doc/browser/DocumentDetailView.vue') },

      // Document management — admin
      { name: 'doc-storage-sources', path: 'doc/admin/storage-sources', component: () => import('@/views/doc/admin/StorageSourceListView.vue') },
      { name: 'doc-storage-source-new', path: 'doc/admin/storage-sources/new', component: () => import('@/views/doc/admin/StorageSourceFormView.vue') },
      { name: 'doc-storage-source-edit', path: 'doc/admin/storage-sources/:id', component: () => import('@/views/doc/admin/StorageSourceFormView.vue') },

      { name: 'doc-classification-plans', path: 'doc/admin/classification-plans', component: () => import('@/views/doc/admin/ClassificationPlanListView.vue') },
      { name: 'doc-classification-plan-new', path: 'doc/admin/classification-plans/new', component: () => import('@/views/doc/admin/ClassificationPlanFormView.vue') },
      { name: 'doc-classification-plan-edit', path: 'doc/admin/classification-plans/:id', component: () => import('@/views/doc/admin/ClassificationPlanFormView.vue') },

      { name: 'doc-retention-rules', path: 'doc/admin/retention-rules', component: () => import('@/views/doc/admin/RetentionRuleListView.vue') },
      { name: 'doc-retention-rule-new', path: 'doc/admin/retention-rules/new', component: () => import('@/views/doc/admin/RetentionRuleFormView.vue') },
      { name: 'doc-retention-rule-edit', path: 'doc/admin/retention-rules/:id', component: () => import('@/views/doc/admin/RetentionRuleFormView.vue') },

      { name: 'doc-document-types', path: 'doc/admin/document-types', component: () => import('@/views/doc/admin/DocumentTypeListView.vue') },
      { name: 'doc-document-type-new', path: 'doc/admin/document-types/new', component: () => import('@/views/doc/admin/DocumentTypeFormView.vue') },
      { name: 'doc-document-type-edit', path: 'doc/admin/document-types/:id', component: () => import('@/views/doc/admin/DocumentTypeFormView.vue') },

      { name: 'doc-vaults-admin', path: 'doc/admin/vaults', component: () => import('@/views/doc/admin/VaultAdminListView.vue') },
      { name: 'doc-vault-admin-new', path: 'doc/admin/vaults/new', component: () => import('@/views/doc/admin/VaultAdminFormView.vue') },
      { name: 'doc-vault-admin-edit', path: 'doc/admin/vaults/:id', component: () => import('@/views/doc/admin/VaultAdminFormView.vue') },

      // Document management — operational
      { name: 'doc-legal-holds', path: 'doc/legal-holds', component: () => import('@/views/doc/operations/LegalHoldListView.vue') },
      { name: 'doc-dispositions', path: 'doc/dispositions', component: () => import('@/views/doc/operations/DispositionEventListView.vue') },
      { name: 'doc-privacy-registry', path: 'doc/privacy-registry', component: () => import('@/views/doc/operations/PrivacyRegistryListView.vue') },
      { name: 'doc-privacy-registry-new', path: 'doc/privacy-registry/new', component: () => import('@/views/doc/operations/PrivacyRegistryFormView.vue') },
      { name: 'doc-privacy-registry-edit', path: 'doc/privacy-registry/:id', component: () => import('@/views/doc/operations/PrivacyRegistryFormView.vue') },
    ]
  },
];
